:host{display:flex;gap:8px;color:#232426;opacity:.6}:host .breadcrumb-divider{color:#232426;opacity:.12}:host div.danger{color:#e31c3d}
/*# sourceMappingURL=objectless-last-saved-badge.component.css.map */
